"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import { FaRegBookmark, FaRegCommentDots } from "react-icons/fa";
import { MessageIcon } from "../ui/message-icon";
import { BOOKMARK_CATEGORIES } from "@/lib/api/public-client";
import ImageWithText from "../ui/imagewithtext";
import { LiveTag } from "../ui/LiveTag";
import { FALLBACK_IMAGE } from '@/lib/constants';
import { getFocusPointStyle, ImageMetadata, BLUR_PLACEHOLDER } from '@/lib/componentutills';
type Props = {
  category?: string;
  title?: string;
  excerpt?: string;
  imageSrc?: string;
  slug?: string;
  imageMetadata?: ImageMetadata;
};
export default function BigVideonews(t0) {
  const $ = _c(24);
  const {
    category: t1,
    title: t2,
    excerpt: t3,
    imageSrc: t4,
    slug,
    imageMetadata
  } = t0;
  t1 === undefined ? "INDIA" : t1;
  const title = t2 === undefined ? "\u0B9F\u0BC1\u0BB5\u0BC8\u0BA9\u0BCD \u0BAA\u0BBF\u0BB0\u0BBE\u0BB5\u0BCB \u0BAE\u0BB1\u0BCD\u0BB1\u0BC1\u0BAE\u0BCD \u0B95\u0BBF\u0BB0\u0BBE\u0BA9\u0BCD \u0BAA\u0BCA\u0BB2\u0BCD\u0BB2\u0BBE\u0BB0\u0BCD\u0B9F\u0BCD \u0BB9\u0BBF\u0BB2\u0BBE\u0BB0\u0BBF\u0BAF\u0BCB\u0BB5\u0BBF\u0BA9\u0BCD \u0BAA\u0BBE\u0BA3\u0BCD\u0B9F\u0BB0\u0BCD \u0B85\u0BAA\u0BBF\u0B9F\u0BC6\u0BB0\u0BC7 \u0B9A\u0BBF\u0BB2\u0BCD\u0B95\u0BCD 5\u0BB5\u0BA4\u0BC1 \u0BAA\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0BC8 \u0BB5\u0BC6\u0BA9\u0BCD\u0BB1\u0BA9\u0BB0\u0BCD, \u0BB5\u0BC0\u0B9F\u0BBF\u0BAF\u0BCB \u0BB5\u0BC8\u0BB0\u0BB2\u0BBE\u0B95\u0BC1\u0BAE\u0BCD" : t2;
  const excerpt = t3 === undefined ? "\u0B9F\u0BC1\u0BB5\u0BC8\u0BA9\u0BCD \u0BAA\u0BBF\u0BB0\u0BBE\u0BB5\u0BCB \u0BAE\u0BB1\u0BCD\u0BB1\u0BC1\u0BAE\u0BCD \u0B95\u0BBF\u0BB0\u0BBE\u0BA9\u0BCD \u0BAA\u0BCA\u0BB2\u0BCD\u0BB2\u0BBE\u0BB0\u0BCD\u0B9F\u0BCD \u0BB9\u0BBF\u0BB2\u0BBE\u0BB0\u0BBF\u0BAF\u0BCB\u0BB5\u0BBF\u0BA9\u0BCD \u0BAA\u0BBE\u0BA3\u0BCD\u0B9F\u0BB0\u0BCD \u0B85\u0BAA\u0BBF\u0B9F\u0BC6\u0BB0\u0BC7 \u0B9A\u0BBF\u0BB2\u0BCD\u0B95\u0BCD 5\u0BB5\u0BA4\u0BC1 \u0BAA\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0BC8 \u0BB5\u0BC6\u0BA9\u0BCD\u0BB1\u0BA9\u0BB0\u0BCD, \u0BB5\u0BC0\u0B9F\u0BBF\u0BAF\u0BCB \u0BB5\u0BC8\u0BB0\u0BB2\u0BBE\u0B95\u0BC1\u0BAE\u0BCD. \u0B9F\u0BC1\u0BB5\u0BC8\u0BA9\u0BCD \u0BAA\u0BBF\u0BB0\u0BBE\u0BB5\u0BCB \u0BAE\u0BB1\u0BCD\u0BB1\u0BC1\u0BAE\u0BCD \u0B95\u0BBF\u0BB0\u0BBE\u0BA9\u0BCD \u0BAA\u0BCA\u0BB2\u0BCD\u0BB2\u0BBE\u0BB0\u0BCD\u0B9F\u0BCD \u0BB9\u0BBF\u0BB2\u0BBE\u0BB0\u0BBF\u0BAF\u0BCB\u0BB5\u0BBF\u0BA9\u0BCD \u0BAA\u0BBE\u0BA3\u0BCD\u0B9F\u0BB0\u0BCD \u0B85\u0BAA\u0BBF\u0B9F\u0BC6\u0BB0\u0BC7 \u0B9A\u0BBF\u0BB2\u0BCD\u0B95\u0BCD 5\u0BB5\u0BA4\u0BC1 \u0BAA\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0BC8 \u0BB5\u0BC6\u0BA9\u0BCD\u0BB1\u0BA9\u0BB0\u0BCD, \u0BB5\u0BC0\u0B9F\u0BBF\u0BAF\u0BCB \u0BB5\u0BC8\u0BB0\u0BB2\u0BBE\u0B95\u0BC1\u0BAE\u0BCD" : t3;
  const imageSrc = t4 === undefined ? FALLBACK_IMAGE : t4;
  let t5;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <LiveTag id="live-tag-big-video" />;
    $[0] = t5;
  } else {
    t5 = $[0];
  }
  const t6 = slug ? `/${slug}` : undefined;
  let t7;
  if ($[1] !== excerpt || $[2] !== imageSrc || $[3] !== slug || $[4] !== t6 || $[5] !== title) {
    t7 = <div className="flex justify-between items-center">{t5}<div className="flex items-center justify-between"><MessageIcon id="message-icon-1" slug={slug} category={BOOKMARK_CATEGORIES.VIDEOS} title={title} thumbnailUrl={imageSrc} description={excerpt} articleUrl={t6} /></div></div>;
    $[1] = excerpt;
    $[2] = imageSrc;
    $[3] = slug;
    $[4] = t6;
    $[5] = title;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== title) {
    t8 = <h3 className="text-012061 text-24-tamil-700 md:text-16-tamil-700 leading-[1.5]">{title}</h3>;
    $[7] = title;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== excerpt) {
    t9 = <p className="text-4D4D4D text-18-tamil-400 leading-[1.5] line-clamp-3">{excerpt}</p>;
    $[9] = excerpt;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== t7 || $[12] !== t8 || $[13] !== t9) {
    t10 = <div className="flex flex-col gap-4">{t7}{t8}{t9}</div>;
    $[11] = t7;
    $[12] = t8;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  const t11 = title || "";
  let t12;
  if ($[15] !== imageMetadata) {
    t12 = getFocusPointStyle(imageMetadata);
    $[15] = imageMetadata;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] !== imageSrc || $[18] !== t11 || $[19] !== t12) {
    t13 = <div className="relative w-full aspect-[16/9] overflow-hidden"><Image src={imageSrc} alt={t11} fill={true} sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 500px" className="object-cover" style={t12} loading="lazy" placeholder="blur" blurDataURL={BLUR_PLACEHOLDER} /></div>;
    $[17] = imageSrc;
    $[18] = t11;
    $[19] = t12;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== t10 || $[22] !== t13) {
    t14 = <article className="flex flex-col overflow-hidden p-4 gap-4">{t10}{t13}</article>;
    $[21] = t10;
    $[22] = t13;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  return t14;
}